import { Outlet, useNavigate } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";
import useLocalStorage from "../hooks/useLocalStorage";
import { useEffect } from "react";
import Swal from "sweetalert2";

export default function Root() {
    const navigate = useNavigate();
    const [hasSeenTutorial, setHasSeenTutorial] = useLocalStorage(
        "hasSeenTutorial",
        "false"
    );

    useEffect(() => {
        if (hasSeenTutorial === "false") {
            Swal.fire({
                title: "Tutorial",
                html: "Olá tudo bem? Quer aprender a utilizar o buscador de vídeos do <b>Robozinho do XVIDEOS</b>? Basta ver o tutorial no link abaixo!",

                color: "#ffffff",
                background: "#121212",

                confirmButtonText: "Ver tutorial",
                confirmButtonColor: "#f00000",

                showCancelButton: true,

                focusCancel: true,
                cancelButtonText: "Cancelar",
            }).then((data) => {
                if (data.value) {
                    navigate("/");
                }
            });

            setHasSeenTutorial("true");
        }
    }, [hasSeenTutorial]);

    return (
        <div className="flex min-h-screen flex-col items-center bg-xv-bg-1 text-lg text-white">
            <Header />

            <main className="flex w-full flex-col items-center">
                <Outlet />
            </main>

            <Footer />
        </div>
    );
}
